<p-menu #menu [popup]="true" [model]="items"></p-menu>
<p-button
  (click)="menu.toggle($event)"
  label="EN"
  styleClass="p-button-sm p-button-text p-button-plain"
  icon="pi pi-chevron-down"
  iconPos="right"
>
</p-button>
